import { useContext } from 'react';
import { RootStoreContext } from '@uplift/contexts';

export function useStore() {
  return useContext(RootStoreContext);
}
